function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import ReactDatePicker from 'react-datepicker';
import classNames from 'classnames';
import 'react-datepicker/dist/react-datepicker.css';
import './index.scss';

const DateCommon = ({
  name,
  value,
  placeholder,
  onChange,
  className,
  isInvalid,
  isValid,
  ...props
}) => {
  const handleChange = (date, _event) => {
    const target = {
      name,
      value: date
    };
    onChange && onChange({ ...target,
      target
    });
  };

  return /*#__PURE__*/React.createElement(ReactDatePicker, _extends({
    dateFormat: "dd/MM/yyyy"
  }, props, {
    wrapperClassName: classNames('', {
      'is-invalid': isInvalid,
      'is-valid': isValid
    }),
    className: classNames('form-control', {
      'is-invalid': isInvalid,
      'is-valid': isValid
    }, className),
    selected: value,
    placeholderText: placeholder,
    onChange: handleChange,
    autoComplete: "new-password"
  }));
};

export default DateCommon;